import { STRATEGY_ACTIVE_ORDER_COUNT_INPUT_ID } from "testIds";
import React from "react";
import SliderAndInput from "features/configuration/GeneralConfiguration/ConfigurationItem/StrategyItem/SliderAndInput";
import { HelperTooltip } from "common/Tooltips/HelperTooltip";
import TitleWithToggle from "features/bots/BotForm/common/TitleWithToggle";
import { useStrategyNumActiveOrders } from "@shared/features/bots/BotForm/common/hooks";
import Text from "common/Typography/Text";
import EqualColumnsGrid from "common/Grids/EqualColumnsGrid";

const StrategyNumActiveOrders = () => {
  const { toggleFieldData, numActiveOrdersSelectorData, singleColumnLayout } =
    useStrategyNumActiveOrders();

  const numActiveOrdersSelector = numActiveOrdersSelectorData?.show ? (
    <SliderAndInput
      inputTestId={STRATEGY_ACTIVE_ORDER_COUNT_INPUT_ID}
      key={numActiveOrdersSelectorData.title}
      name={
        toggleFieldData.isToggleField
          ? undefined
          : numActiveOrdersSelectorData.title
      }
      value={numActiveOrdersSelectorData.value}
      setValue={numActiveOrdersSelectorData.onChange}
      maxValue={numActiveOrdersSelectorData.maxValue}
      step={numActiveOrdersSelectorData.step}
      minValue={numActiveOrdersSelectorData.minValue}
      showError={numActiveOrdersSelectorData.showError}
      useDebounce={true}
      placeholder={numActiveOrdersSelectorData.placeholder}
      helperTooltip={
        toggleFieldData.isToggleField ? undefined : (
          <HelperTooltip {...numActiveOrdersSelectorData.helperTooltipData} />
        )
      }
    />
  ) : undefined;

  if (toggleFieldData.isToggleField && numActiveOrdersSelectorData?.show) {
    return (
      <div style={{ marginBottom: 16 }}>
        <TitleWithToggle
          title={
            <Text>
              {numActiveOrdersSelectorData.title}
              <HelperTooltip
                {...numActiveOrdersSelectorData.helperTooltipData}
              />
            </Text>
          }
          content={
            <EqualColumnsGrid
              numColumns={singleColumnLayout ? 1 : 2}
              style={{ marginBottom: -8, marginLeft: 4 }}
              rowGap={4}
            >
              {numActiveOrdersSelector}
            </EqualColumnsGrid>
          }
          fieldType={toggleFieldData.fieldType}
        />
      </div>
    );
  }

  return <>{numActiveOrdersSelector}</>;
};

export default StrategyNumActiveOrders;
